<template>
  <section v-if="error">
  <br/>
  <p class="error">{{ error }}</p>
  </section>
  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section>
            <div class="grid-x grid-margin-x" v-if="isCurrentPayrollSoftwareProviderSupported()">
                <div class="cell small-12">
                    <h1>Provide Your Data</h1>
                    <p>You have selected that you will be migrating from {{ currentPayrollSoftwareProvider }}.</p>
                    <p>Qtac are able to migrate the data from {{ currentPayrollSoftwareProvider }}, and you will be contacted by your Qtac account manager with further instructions.</p>
                    <p>If you have any questions in the meantime, please don't hesitate to reach out to your account manager.</p>
                </div>
            </div>
            <div v-else class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <h1>Provide Your Data</h1>
                    <p>In order to set up your payroll, we need to collect data files from you to allow us to set your payroll up on our systems.</p>
                    <p>Please complete each of the tasks below.</p>
                </div>
                <div class="cell small-12">
                    <Panel
                        v-for="(panel, idx) in panelCards"
                        :key="idx"
                        :title="panel.title"
                        :description="panel.subtitle"
                        :status="splitByCapitals(panel.status)"
                        :icon="panel.icon"
                        :route="panel.route"
                    />
                </div>
            </div>
            <br/>
            <button v-if="userType == 'Administrator'" class="btn btn-primary" @click="markFilesAsComplete">Mark Data As Collected</button>
            <button class="btn btn-secondary" @click="router.push({ name: 'Home' })">Return to Home</button>
        </section>

        


</div>


  </section>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { splitByCapitals } from '@/helpers/strings';
import Panel from '@/components/controls/Panel.vue'
import { buildCards } from '@/helpers/panelcard/cardfactory'
import { useIdentityStore } from '@/stores/identity';
import supportedPreviousPayrollProviders from '@/helpers/arrays/supportedPreviousPayrollProviders';


const router  = useRouter()
const loaded = ref(false);
const error = ref(null);

import { getFileCollectionTasks, postFileCollectionsAsComplete, getProjectTasks, getPreDiscoveryChecklist } from '@/services/implementationmanagement.api';

const errorString = 'An error has occurred. Please contact your Qtac account manager.';

import { useProjectStore } from '@/stores/project'
const project = useProjectStore()

const containerId = router.currentRoute.value.params.containerId;
const panelCards = ref([])
const identity = useIdentityStore();
const userType = computed(() => identity.type)
const currentPayrollSoftwareProvider = ref('');

onMounted(async () => {

    try {

        let fileCollectionTasks = await getFileCollectionTasks(project.projectId);



        if (fileCollectionTasks && fileCollectionTasks.status !== 204) {
            fileCollectionTasks = fileCollectionTasks.data;

            panelCards.value = await buildCards(fileCollectionTasks, true);
        }

        getCurrentPayrollSoftwareProvider();

    } catch (err) {
        error.value = errorString; 
        console.error(err);
    }




loaded.value = true;
})


const markFilesAsComplete = async () => {
    try {
        // Call API to mark files as collected
        await postFileCollectionsAsComplete(containerId);
        router.push({ name: 'Home' });
    } catch (err) {
        error.value = errorString;
        console.error(err);
    }
}

const getCurrentPayrollSoftwareProvider = async () => {
    try {

        var prediscoveryChecklistTaskId = (await getProjectTasks(project.projectId)).data.find(t => t.taskType === "PreDiscoveryChecklist")?.taskId;

        var prediscoveryChecklist = (await getPreDiscoveryChecklist(prediscoveryChecklistTaskId)).data;

            const json = prediscoveryChecklist.preDiscoveryChecklistJson;
            var parsed = typeof json === 'string' ? JSON.parse(json) : json;

            currentPayrollSoftwareProvider.value = parsed?.currentPayrollSoftwareProvider;


    } catch (err) {
        console.error('Error fetching current payroll software provider:', err);
        return 'your current payroll software provider';
    }
}

const isCurrentPayrollSoftwareProviderSupported = () => {

    return supportedPreviousPayrollProviders.includes(currentPayrollSoftwareProvider.value);

}

</script>

